import Vue from "vue";
import App from "./AppHcoList.vue";
// import router from "./router";
import store from "./store";

import "@/plugins/default";
import "@/plugins/vue-bootstrap";
import "@/plugins/vue-moment";
import "@/plugins/vue-axios";

Vue.config.productionTip = false;

import "@/styles/main.scss";

new Vue({
  // router,
  store,
  render: h => h(App),
  async created() {
    await this.$store.dispatch("App/getConfig");
  }
}).$mount("#app");
